import HardcodedBillingAgencyRepository from './HardcodedBillingAgencyRepository';
import BillingAgencyRepository from '../../../domain/user/profile/BillingAgencyRepository';

export const billingAgencyRepository: BillingAgencyRepository = new HardcodedBillingAgencyRepository();
